import Cookies from 'js-cookie'

export function setSilentMode(silent) {
    Cookies.set("silent", silent, {expires: 365})
}

export function getSilentMode() {
    let s = Cookies.get("silent")

    if (s === undefined) {
        s = false
        return s
    }
    return s === "true"


}